import styled from 'styled-components';
import { Glyphicon } from 'react-bootstrap';

const EnvelopeIcon = styled(Glyphicon).attrs({
  glyph: 'envelope',
})``;

export default EnvelopeIcon;
